// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ranking-list[data-v-17cde592]{display:grid;grid-auto-flow:column;grid-template-rows:repeat(5,1fr);width:100%}@media(max-width:985px){.ranking-list[data-v-17cde592]{gap:16px}}@media(min-width:986px){.ranking-list[data-v-17cde592]{gap:24px;grid-template-columns:1fr 1fr}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
